import { compose } from 'redux'
import { connect } from 'react-redux'
import registerReduxModal from 'components/common/hoc/registerReduxModal'
import * as actions from './actions'
import { APPOINTMENT_CHANGE_MODAL } from '../constants'
import AppointmentChangeModal from './AppointmentChangeModal'

export default compose(
  registerReduxModal({ name: APPOINTMENT_CHANGE_MODAL }),
  connect(null, actions)
)(AppointmentChangeModal)
